import AlertCircle from "@uui/AlertCircle";
import RefreshIcon from "@uui/RefreshCw01";

import { SxProps } from "@mui/material";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
} from "@rui/EmptyStateContainer";

const ErrorState = ({ refetch, sx }: { refetch: () => void; sx?: SxProps }) => (
  <EmptyStateContainer sx={sx}>
    <EmptyStateIcon Icon={AlertCircle} />
    <EmptyStateSubtext>Oops! Something went wrong</EmptyStateSubtext>
    <Button onClick={refetch} variant="gradient" startIcon={<RefreshIcon />}>
      Try again
    </Button>
  </EmptyStateContainer>
);

export default ErrorState;
